import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';
import { AuthProvider, useAuth } from './context/AuthContext';
import { homePathForRole, isSupervisorRole } from './utils/roles';
import Layout from './components/Layout';
import LoginPage          from './pages/LoginPage';
import MyTimesheetPage    from './pages/MyTimesheetPage';
import MyHistoryPage      from './pages/MyHistoryPage';
import AllTimesheetsPage  from './pages/AllTimesheetsPage';
import MechanicsPage      from './pages/MechanicsPage';
import ReportsPage        from './pages/ReportsPage';
import IPManagementPage   from './pages/IPManagementPage';

function Guard({ children, roles, timesheetOnly }) {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  if (timesheetOnly && isSupervisorRole(user.role)) {
    return <Navigate to={homePathForRole(user.role)} replace />;
  }
  if (roles && !roles.includes(user.role)) {
    return <Navigate to={homePathForRole(user.role)} replace />;
  }
  return <Layout>{children}</Layout>;
}

function Root() {
  const { user } = useAuth();
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={homePathForRole(user.role)} replace />;
}

export default function App() {
  return (
    <AuthProvider>
      <BrowserRouter>
        <Routes>
          <Route path="/login" element={<LoginPage />} />
          <Route path="/" element={<Root />} />

          {/* Timesheet routes (all roles except supervisor) */}
          <Route path="/my-timesheet" element={
            <Guard timesheetOnly><MyTimesheetPage /></Guard>
          }/>
          <Route path="/my-history" element={
            <Guard timesheetOnly><MyHistoryPage /></Guard>
          }/>

          {/* Supervisor routes */}
          <Route path="/all-timesheets" element={
            <Guard roles={['supervisor', 'admin']}><AllTimesheetsPage /></Guard>
          }/>
          <Route path="/mechanics" element={
            <Guard roles={['supervisor', 'admin']}><MechanicsPage /></Guard>
          }/>
          <Route path="/reports" element={
            <Guard roles={['supervisor', 'admin']}><ReportsPage /></Guard>
          }/>
          <Route path="/ip-management" element={
            <Guard roles={['supervisor', 'admin']}><IPManagementPage /></Guard>
          }/>

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </AuthProvider>
  );
}
